export const getPlugins = (state) => state?.plugins?.list || [];
